module.exports = __webpack_public_path__ + "img/ch79.a1e56e10.png";